import React from "react";

import SalesRecordComponent from "../components/SalesRecord/SalesRecordComponent";

const SalesRecordPage = () => {
  return <SalesRecordComponent />;
};

export default SalesRecordPage;
